function recordKey(record = {}) {
  return String(record?.record_key ?? record?.recordKey ?? '').trim();
}

export function mergeRaidOverviewRecordDelta(currentRecords = [], deltaRecords = []) {
  const merged = new Map();
  for (const record of Array.isArray(currentRecords) ? currentRecords : []) {
    const key = recordKey(record);
    if (key) merged.set(key, record);
  }
  for (const record of Array.isArray(deltaRecords) ? deltaRecords : []) {
    const key = recordKey(record);
    if (key) merged.set(key, record);
  }
  return [...merged.values()];
}

export function raidOverviewDeltaNeedsSnapshot({
  batchRows = [],
  batchLimit = 64,
  deltaCount = 0,
  deltaLimit = 5000,
} = {}) {
  const batches = Array.isArray(batchRows) ? batchRows : [];
  if (batches.length >= batchLimit) return true;
  if (batches.some((row) => Number(row?.removed_count ?? row?.removedCount ?? 0) > 0)) return true;
  return Number(deltaCount || 0) >= deltaLimit;
}
